<template>
	<div>
		<v-card class="mx-auto experienceCard" max-width="344" :loading="loading" @click="openInNewTab(experience.url)">
			<template v-slot:loader="{ isActive }">
				<v-progress-linear
					:active="isActive"
					color="deep-purple"
					height="4"
					indeterminate
				></v-progress-linear>
			</template>
			<v-img
				:src="`${experience.image}`"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<div style="text-align: left">
				<div class="card-title bold">{{experience.name}}</div>
				<v-card-subtitle style="padding-top: 0px;">{{experience.category_names}}</v-card-subtitle>
				<v-card-text style="padding-bottom: 0px;">{{experience.tagline}}</v-card-text>
			</div>
			<v-divider class="mx-4 mb-1"></v-divider>
			<div class="px-4">
				<v-chip-group>
					<v-chip><strong style="margin-left: 10px;"> {{experience.priceFrom}}  €</strong></v-chip>
				</v-chip-group>
			</div>
			<div class="container" v-if="parentExpIds.indexOf(parseInt(experience.id)) > -1">
				<div class="add-btn">{{ $t('addedToCatalogue') }}</div>
			</div>
			<!-- PULSE ICON -->
			<div class="pulseContainer" v-else-if="!disableAddBtn" @click="addExperienceToCatalogue">
				<div class="pulse">
					<svg
						version="1.1"
						id="Capa_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 60.364 60.364"
						style="enable-background:new 0 0 60.364 60.364;"
						xml:space="preserve"
					>
					<g>
						<path fill=#fff
							d="M54.454,23.18l-18.609-0.002L35.844,5.91C35.845,2.646,33.198,0,29.934,0c-3.263,0-5.909,2.646-5.909,5.91v17.269
							L5.91,23.178C2.646,23.179,0,25.825,0,29.088c0.002,3.264,2.646,5.909,5.91,5.909h18.115v19.457c0,3.267,2.646,5.91,5.91,5.91
							c3.264,0,5.909-2.646,5.91-5.908V34.997h18.611c3.262,0,5.908-2.645,5.908-5.907C60.367,25.824,57.718,23.178,54.454,23.18z"
							/>
					</g>
					</svg>
				</div>
			</div>
			<!-- end of PULSE ICON -->
		</v-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			id: this.experience.id,
			disableAddBtn: false,
			loading: false,
			showDetails: false,
		}
	},
	mounted() {
	},
	methods: {
		openInNewTab(url) {
      		window.open(url, '_blank')
    	},
		reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
      	},
		async addExperienceToCatalogue(event) {
			event.stopPropagation()
			this.disableAddBtn = true
			try {
				const expBody = { 
					parent_experience_id: this.experience.id,
					client_id: this.inquireDetails.id,
					name: this.experience.name,
					description: this.experience.tagline,
					categories: this.experience.categories.toString().split(',').join(', '),
					price_min: this.experience.priceFrom,
					url: this.experience.domainUrl,
					img_path: this.experience.image
				}
				await this.$store.dispatch('marketPlace/addExpToCatalogue', expBody)
                alert(this.$t('experienceAdded'))
				this.$emit('refresh-list', null)
			} catch (error) {
				this.disableAddBtn = false
				alert(this.$t('tryLater'))
			}
		}
	},
	props: {
		experience: {
			type: Object,
			default: () => {
				return {}
			}
		},
		inquireDetails: {
			type: Object,
			default: () => {
				return {}
			}
		},
		parentExpIds: {
			type: Array,
			default: () => {
				return []
			}
		}
	}
}
</script>

<style lang="scss" scoped>

.fitProductImage {
	width: 100% !important;
  	object-fit: cover !important;
}

.experienceCard {
	height: 450px !important;
	margin: 20px 10px !important;
}
.experienceCard:hover {
	background: rgba(128, 128, 128, 0.1) !important;
	box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
	margin: 10px !important;
	transform: scale(1.03);
}
.pulseContainer  {
	background: none !important;
	position: absolute;
    bottom: -12px;
    right: 30px;
}

.card-title {
	width: 320px;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	margin-top:10px;
	margin: auto;
	font-size: 1.5rem;
	font-weight: 800;
	margin: auto;
}
.bold {
	font-weight: 700 !important;

}

.description {
	max-height: 200px;
	white-space: inherit;
	overflow: hidden;
	text-overflow: ellipsis;
	text-align: justify;
    font-size: 0.7rem;
}

.container  {
	position: absolute;
    top: 0;
    left: 0%;
	padding-top:0;
}

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	// padding: 0.3em;
	letter-spacing: 3.5px;
	text-transform: uppercase;
	width: auto;
}
.trashIcon {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 0.3em;
	letter-spacing: 3px;
	border: none;
	border-radius: 3.5px;
	width: 40px;
	height: 35px;
	position: relative;
	display: block;
	top: -25px;
	left: -33px;
}
.inquiry-btn {
	color: var(--bg-light) !important;
	border: 1px solid var(--bg-light);
	background: none;
	text-decoration: none;
	text-transform: uppercase;
	font-weight: 500;
	letter-spacing: 1px;
	font-size: 1em;
	padding: 5px 10px;
	border-radius: 5px;
	transition: 0.3s;
	transition-property: background;
	margin: auto;
	width: 100%;
	margin-bottom: 10px;
	margin-top: 10px;
}

.inquiry-btn:hover {
	background: var(--primaryDark);
	color: var(--bright) !important;
}
.icon {
	font-size: 1.3em;
	padding: 1px;
	float: right;
	cursor: pointer;
}

  .card {
    box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
    transition: .15s all ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }

@keyframes pulse {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7), 0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  40% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  80% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
}

div[class^='pulse'] {
  background: var(--primaryDark);
  border-radius: 50%;
  color: white;
  cursor: pointer;
  height: auto;
  margin: auto;
  padding: 1.2em;
  text-align: center;
  width: 60px;
}

.pulse:active {
  animation: pulse 0.25s infinite ease-out;
}
.pulse:hover {
  background: #c95c5f;
}

@media only screen and (min-device-width: 500px) {
	.card-title {
		margin-top: 10px;
		line-height: 30px;
	}
}
@media only screen and (max-device-width: 769px) {
	.experienceCard {
		height: auto !important;
	}
}

@media only screen and (max-device-width: 500px) {
	.experienceCard {
		margin: auto;
	}
	.card-title {
		margin-top: 8px;
		line-height: 25px;
	}
	.card {
		margin-bottom: 20px;
	}
}
@media only screen and (min-device-width: 300px) and (max-device-width: 359px){
	.card-title {
	width: 240px;
	font-size: 1.2rem;
}
.sendInquiryBtn {
	font-size: 0.7rem !important;
}
.readMoreBtn {
	font-size: 0.7rem !important;
}
}
@media only screen and (min-device-width: 300px) and (max-device-width: 1050px){
.pulseContainer {
	bottom: -15px !important;
    right: 15px !important;
}
.pulse {
	padding: 10px !important;
    width: 40px !important;
}
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px){
	.card-title {
	width: 270px;
}
}
@media only screen and (min-device-width: 381px) {
	.card-title {
	width: 300px;
}
}
</style>
